<template>
	<div class="white-box" >
		<preloader-view v-if="isLoadingInitial"></preloader-view>

		<div v-else>
			<div class="styled-form__header o-v-rhythm--small text--center" v-if="showedHeader">

				<div v-if="isLoading" class="styled-form__overlay">
					<div class="preloader"></div>
				</div>

				<global-message v-if="skipErrors.global" :value="skipErrors.global"></global-message>
			</div>

			<div
				:class="[
					'o-v-rhythm',
					'styled-form',
					{'is-loading': isLoading}
				]"
			>

				<div v-if="isLoading" class="styled-form__overlay">
					<div class="preloader"></div>
				</div>

				<global-message v-if="errors.global" :value="errors.global"></global-message>
                <offer-form-group-partner
					v-show="hasPartnerOffers"
					header="Football Australia"
					sub-title="EXCLUSIVES, SUPPORT AND OFFERS"
					sub-header="Start your season off with exclusive invitations, offers, experiences and competitions - available only to registered participants. Plus show your support for the Pararoos!"
					:checkboxes="offerGroup.checkboxes"
					:groupheading="offerGroup.heading"
					class="bottom-gap-15"
					group-name="offerGroup"
					:clickHandler="checkboxClickHandler"
				>
                
				</offer-form-group-partner>
                 <div class="common__sub-heading bottom-gap-25">Terms and Conditions
                    <a href = "https://www.playfootball.com.au/sites/play/files/2020-12/20-1214 - PlayFootball - Win the National Team Jersey.pdf" target="new" class="styled-form__link"> CLICK HERE </a>
                </div>
				<offer-form-group
					v-show="hasClubOffers"
					header="CLUB OFFERS"
					sub-title="A-League/Westfield W-League offers"
					sub-header="If you have registered a Junior Participant, you can redeem a special Membership offer to watch your heroes in action! Once redeemed, you will receive an email from your A-League/Westfield W-League club within three weeks."
					:checkboxes="offerGroup.checkboxes"
					:groupheading="offerGroup.heading"
					class="bottom-gap-15"
					group-name="offerGroup"
					:clickHandler="checkboxSingleClickHandler"
				>
				</offer-form-group>

				<div class="text--center">
					<button
						type="button"
						:class="['btn gtm-offer-' + showSaveButton.toLowerCase()]"
						@click.prevent="onSubmit"
					>{{ showSaveButton }}</button>
				</div>
			</div>
		</div>

	</div>
</template>


<script>
    import { cloneDeep } from 'lodash';
    import { mapState, mapGetters } from 'vuex';
    import PreloaderView from '../views/PreloaderView.vue';
    import TilesFormGroup from '../formGroups/TilesFormGroup.vue';
    import OfferFormGroup from '../formGroups/OfferFormGroup.vue';
    import OfferFormGroupPartner from "../formGroups/OfferFormGroupPartner";
    import CheckboxesFormGroup from '../formGroups/CheckboxesFormGroup.vue';
    import DisableCommunicationsGroup from '../formGroups/DisableCommunicationsGroup.vue';
    import GlobalMessage from '../messages/GlobalMessage.vue';
    import Checkbox from '../formFields/Checkbox.vue';
    import SlideDown from '../animations/SlideDown.vue';
    import api from "../../api";

    export default {
      components: {
        GlobalMessage,
        PreloaderView,
        TilesFormGroup,
        CheckboxesFormGroup,
        DisableCommunicationsGroup,
        Checkbox,
        SlideDown,
        OfferFormGroup,
        OfferFormGroupPartner
      },
      props: {
        user: {
          type: Object
        }
      },
      data() {
        return {
          destroyData: true,
          stateCopy: null,
          isLoadingInitial: false,
          isLoading: false,
          errors: {},
          skipErrors: {},
          hasOffers: false,
          hasUsername: false,
          hasClubOffers: false,
          hasPartnerOffers: false,
          clubCheckBoxHold: [],
        }
      },
      mounted() {
        if (this.user && this.user.username) this.hasUsername = true;
      },
      computed: {
        ...mapGetters('onboarding', [
          'clubGroupChecked',
          'leagueGroupChecked',
          'priorityTicketingIsChecked',
          'checkboxGroupChecked',
          'disableGroupChecked',
          'offerGroupChecked',
          'optinGroupChecked'
        ]),
        ...mapState('onboarding', {
          onboardingState: state => state,
          form: state => state.form || {},
          clubGroup: state => state.formGroups.clubGroup,
          leagueGroup: state => state.formGroups.leagueGroup,
          priorityTicketingCheckbox: state => state.formGroups.priorityTicketing,
          checkboxGroup: state => state.formGroups.checkboxGroup,
          disableGroup: state => state.formGroups.disableGroup,
          offerGroup: state => state.formGroups.offerGroup,
          optinGroup: state => state.formGroups.optinGroup
        }),
        showedHeader() {
          /*
				* newCustomer
				* existingCompleted
				* existingNotCompleted
				* */
          let result = false;
          if (this.form) {
            switch (this.form.onboarding) {
              case 'New':
                switch (this.form.onboardingcomplete) {
                  case 'Not Completed':
                    result = 'newCustomer';
                    break;
                  case 'Completed':
                  case 'Skipped':
                    result = 'existingCompleted';
                    break;
                }
                break;
              case 'Existing':
                switch (this.form.onboardingcomplete) {
                  case 'Not Completed':
                    result = 'existingNotCompleted';
                    break;
                  case 'Completed':
                  case 'Skipped':
                    result = 'existingCompleted';
                    break;
                }
                break;
            }
          }

          return result;
        },
        showSaveButton() {
          /*
                * newCustomer
                * existingCompleted
                * existingNotCompleted
                * */
          let result = '';
          if (this.form) {
            switch (this.form.onboarding) {
              case 'New':
                switch (this.form.onboardingcomplete) {
                  case 'Not Completed':
                    result = 'Continue';
                    break;
                  case 'Completed':
                  case 'Skipped':
                    result = 'Continue';
                    break;
                }
                break;
              case 'Existing':
                result = 'Continue';
                break;
            }
          }

          return result;
        },
        clubsSupported() {
          const clubsSupported = {};

          this.clubGroup.checkboxes.forEach(club => {
            clubsSupported[club.id] = club.isChecked;
          });

          return clubsSupported;
        },
        subscriptions() {
          const leagueSubscriptions = this.leagueGroupChecked.map(league => ({
            'ffa_name': league.id,
            'statecode': 0,
            'ffa_membershipstatus': true
          }));

          const otherSubscriptions = this.checkboxGroupChecked.map(checkbox => ({
            'ffa_name': checkbox.id,
            'statecode': 0,
            'ffa_membershipstatus': true
          }));

          const resultArray = [
            ...leagueSubscriptions,
            ...otherSubscriptions
          ];

          if (this.priorityTicketingIsChecked) {
            resultArray.push({
              'ffa_name': this.priorityTicketingCheckbox.checkboxes[0].id,
              'statecode': 0,
              'ffa_membershipstatus': true
            });
          }

          return resultArray;
        },
        otherSettings() {
          const otherSettings = {};

          this.disableGroup.checkboxes.forEach(setting => {
            otherSettings[setting.id] = setting.isChecked;
          });

          otherSettings['ffa_unsubscribereason'] = this.disableGroup.checkboxes[0].reasoning[0].value;
          otherSettings['ffa_unsubscribereasonother'] = this.disableGroup.checkboxes[0].reasoning[1].value;

          return otherSettings;
        }
      },
      created() {
        if (!Object.keys(this.form).length) {
          this.isLoadingInitial = true;
          this.$store.dispatch('onboarding/GET_ONBOARDING_DATA').then(() => {
            this.isLoadingInitial = false;
            this.copyState();
          }).catch(errors => {
            this.errors = errors;

            if (errors instanceof Error) {
              // console.error(errors);
            }
          });
        } else {
          this.copyState();
        }
      },
      beforeDestroy() {
        if (this.destroyData) {
          this.$store.commit('onboarding/UPDATE_STATE', this.stateCopy);
        }
      },
      methods: {
        copyState() {
          this.stateCopy = cloneDeep(this.onboardingState);
        },
        checkboxClickHandler(groupName, checkboxIndex) {
          this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', {groupName, checkboxIndex});
        },
        checkboxSingleClickHandler(groupName, checkboxIndex) {
          let exception = this.clubCheckBoxHold;
          this.$store.commit('onboarding/SINGLE_CHECKBOX_STATE', {groupName, checkboxIndex, exception});
        },
        saveOffers() {
          this.redirectAfterSubmit();
        },
        redirectAfterSubmit() {
          this.isLoading = false;
          this.destroyData = false;

          this.$router.push({
            name: 'onBoarding',
            params: {
              message: {
                type: 'success',
                value: 'Your preferences were successfully updated.'
              }
            }
          });
        },
        onSubmit() {
          this.updateOnboardingData();
        },
        onCancel() {
          this.$store.commit('onboarding/UPDATE_STATE', this.stateCopy);
          this.$router.push({name: 'myAccount'});
        },
        updateOnboardingData() {
          // sanitise input field
          if (this.otherSettings.ffa_unsubscribereason) {
            this.otherSettings.ffa_unsubscribereason = this.otherSettings.ffa_unsubscribereason.replace(/<.+?>/g, '');
          }

          if (this.otherSettings.ffa_unsubscribereasonother) {
            this.otherSettings.ffa_unsubscribereasonother = this.otherSettings.ffa_unsubscribereasonother.replace(/<.+?>/g, '');
          }

          const payload = {
            "clubs_supported": this.clubsSupported,
            "subscriptions": this.subscriptions,
            "ffa_donotbulkemail": this.otherSettings.ffa_donotbulkemail ? true : false,
            "ffa_unsubscribereason": (this.otherSettings.ffa_donotbulkemail) ? this.otherSettings.ffa_unsubscribereason : '',
            "ffa_unsubscribereasonother": (this.otherSettings.ffa_donotbulkemail) ? this.otherSettings.ffa_unsubscribereasonother : '',
            "ffa_bulkemailfrequency": (this.otherSettings.ffa_bulkemailfrequency) ? 'Break' : 'All',
          };

          this.isLoading = true;
          if (!this.hasUsername) {
            this.saveOffers();
          } else {
            this.$store.dispatch('onboarding/UPDATE_ONBOARDING_DATA', payload)
                .then(() => {
                  this.saveOffers();
                })
                .catch(errors => {
                  this.isLoading = false;
                  this.errors = errors;
                });
          }
        },
        skipHandler() {
          this.isLoading = true;
          this.$store.dispatch('onboarding/SKIP_PREFERENCES_SELECTION')
              .then(() => {
                this.isLoading = true;
                this.$router.push({
                  name: 'myAccount'
                });
              }).catch(err => {
            this.isLoading = false;
            this.skipErrors = err;
          });
        },
        myFilter: function () {
          this.isActive = !this.isActive;
        }
      }
    };
</script>

<style lang="scss">
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";
	.offers-page {
    .common {
      &__sub-title {
        min-height: 23px;
        font-size: 20px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      &__sub-heading {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.3;
        letter-spacing: normal;
        text-align: left;
        color: #777777;
      }

      &__heading {
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: 0.32px;
        text-align: left;
        color: #00007d;
      }
    }

    a {
      .btn {
        text-decoration: none;
      }
    }

    .offer-form-group {
      &__container {
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: 32% 32% 32%;
        grid-template-columns: 32% 32% 32%;
        -ms-flex-pack: justify;
        justify-content: space-between;
        @include maxq(tablet) { // max-width: 760px
          grid-template-columns: 100%;
        }
      }

      &__item {
        display: -ms-flexbox;
        display: flex;
        display: -webkit-flex;
        -ms-flex-flow: column;
        flex-flow: column;
        -ms-flex-pack: center;
        justify-content: flex-start;
        -ms-flex-align: center;
        align-items: center;
        max-width: 260px;
        @include maxq(tablet) { // max-width: 760px
          max-width: 100%;
        }
      }
    }

    .offer {

      &__inner {
        flex-direction: column;
        border: 1px solid #eaeaea;
      }

      &__img-container {
        width: auto;
        height: 170px;
        @include maxq(tablet) { // max-width: 760px
          height: 360px;
        }
        @include maxq(largeMobile) { // max-width: 320px
          height: 240px;
        }
        @include maxq(mobile) { // max-width: 320px
          height: 170px;
        }
      }

      &__txt-container {
        width: 100%;
        padding: 20px;
      }

      &__img {
        -webkit-background-size: contain;
        -moz-background-size: contain;
        -o-background-size: contain;
        background-size: contain;
      }

      &__checkbox {
        position: relative;
        top: inherit;
        right: inherit;
        width: 18px;
        height: 18px;
      }

      &__checkwrapper {
        border-radius: 5px;
        border: solid 1px #BBBBBB;
        display: flex;
        display: -ms-flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: center;
        height: 40px;
        padding-top: 11px;
        margin-top: 20px;
      }

      &__redeem {
        margin-left: 10px;
        text-transform: uppercase;
        width: 46px;
        height: 12px;
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: normal;
        text-align: center;
        color: #777777;
        margin-top: 2px;
        display: inline-block;
      }

      &__redeemselected {
        display: none;
        color: #61a700 !important;
        margin-left: 10px;
        text-transform: uppercase;
        width: 46px;
        height: 12px;
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: normal;
        text-align: center;
        margin-top: 2px;
      }

      &__agerange {
        height: 26px;
        border: solid 1px #9ec8e1;
        background-color: #d1e9f6;
        font-size: 10px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.82;
        letter-spacing: normal;
        text-align: center;
        color: #3f6a81;
        padding: 4px 0px 4px 0px;
        margin-top: 20px;
        text-transform: uppercase;
      }

      &__description {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #777777;
        height: 59px;
        overflow: hidden;
      }

      &__txt {
        text-transform: initial;
        font-size: 18px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #1e1e1e;
        margin-bottom: 20px;
        height: 42px;
        overflow: hidden;
      }

      &__no-age {
        height: 26px !important;
        display: block;
        position: relative !important;
        background-color: #ffffff !important;
        width: 0px !important;
        margin-top: 20px !important;
      }
    }

    .is-checked {
      .offer__checkwrapper {
        border: solid 3px #61a700;
        padding-top: 8px !important;
      }

      .offer__redeemselected {
        display: inline-block !important;
      }

      .offer__redeem {
        display: none !important;
      }

      &::before {
        box-shadow: none !important;
        -moz-box-shadow: none !important;
        -webkit-box-shadow: none !important;
      }
    }
  }
	.offer__redeem, .offer__redeemselected {
    display: none;
  }

</style>

